// @flow
'use strict';

import * as React from 'react';

import type { IInformacoesAdicionais, IInformacoesPedidoEmissaoNff, IInformacoesComercioExterior } from '../types';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';
import InformacoesPedidoEmissaoNff from './informacoes_pedido_emissao_nff';
import InformacoesComercioExterior from './informacoes_comercio_exterior';

type InformacoesAdicionaisProps = {
  informacoesAdicionais : IInformacoesAdicionais,
  informacoesPedidoEmissaoNff : IInformacoesPedidoEmissaoNff,
  informacoesComercioExterior : IInformacoesComercioExterior,
};

export default function InformacoesAdicionais({ informacoesAdicionais, informacoesPedidoEmissaoNff, informacoesComercioExterior } : InformacoesAdicionaisProps) {
  return (
      <div className="tab-pane active">
        <h3>Informações Adicionais</h3>
        <h4>Informações de Interesse do Fisco</h4>
        <RowDetalhes data={ informacoesAdicionais } headerRow={ false }>
          <ColumnDetalhes field="infInteresseFisco" textoPreformatado />
        </RowDetalhes>
        <h4>Informações de Interesse do Contribuinte</h4>
        <RowDetalhes data={ informacoesAdicionais } headerRow={ false }>
          <ColumnDetalhes field="infInteresseContribuinte" textoPreformatado />
        </RowDetalhes>

        { informacoesPedidoEmissaoNff && <InformacoesPedidoEmissaoNff informacoesPedidoEmissaoNff={ informacoesPedidoEmissaoNff }/> }
        { informacoesComercioExterior && <InformacoesComercioExterior informacoesComercioExterior={ informacoesComercioExterior }/> }
      </div>
  );
}
